const SIGN_UP = 'SIGN_UP';
const SIGN_IN = 'SIGN_IN';
const SIGN_IN_CHANGE_PASSWORD = 'SIGN_IN_CHANGE_PASSWORD';
const SIGN_IN_MFA_SETUP = 'SIGN_IN_MFA_SETUP';
const SIGN_IN_MFA_CODE = 'SIGN_IN_MFA_CODE';
const SIGN_OUT = 'SIGN_OUT';

const DASHBOARD = 'DASHBOARD';
const ACTIVITY_LOG = 'ACTIVITY_LOG';
const REQUESTS = 'REQUESTS';
const NEW_PROJECT = 'NEW_PROJECT';
const PROJECT_DETAILS = 'PROJECT_DETAILS';

const AUTOMATIC_PROJECT_ISSUES = 'projectDetails.tab.automatic.issues';
const PROJECT_ISSUES = 'projectDetails.tab.issues';
const PROJECT_FINDINGS = 'projectDetails.tab.issues.sp';
const PROJECT_GENERAL_INFORMATION = 'projectDetails.tab.general';
const PROJECT_WORK_WITH_PROJECT = 'projectDetails.tab.workWithProject';
const PROJECT_TECHNICAL_INFORMATION = 'projectDetails.tab.technicalInformation';

const CLIENT_INFO = 'CLIENT_INFO';
const REGISTRATION_FINISHED = 'REGISTRATION_FINISHED';
const WORKSPACE_INFO = 'WORKSPACE_INFO';

const SIGN_IN_VERIFY_EMAIL = 'SIGN_IN_VERIFY_EMAIL';

const USER_MANAGEMENT = 'USER_MANAGEMENT';
const SETTINGS = 'SETTINGS';
const INVENTORY = 'INVENTORY';
const NOT_AUTHORIZED = 'NOT_AUTHORIZED';

const EMAIL_VERIFICATION = 'EMAIL_VERIFICATION';
const SP_FREELANCER_CLIENT_INFO = 'SP_FREELANCER_CLIENT_INFO';
const COMPANY_SERVICES = 'COMPANY_SERVICES';
const COMPANY_CERTIFICATION = 'COMPANY_CERTIFICATION';
const SP_FREELANCER_REGISTRATION_FINISHED = 'SP_FREELANCER_REGISTRATION_FINISHED';

const COMPANY_INFO = 'COMPANY_INFO';
const COMPANY_SERVICES_SP = 'COMPANY_SERVICES_SP';
const COMPANY_CERTIFICATIONS_SP = 'COMPANY_CERTIFICATIONS_SP';
const EMAIL_VERIFICATION_SP = 'EMAIL_VERIFICATION_SP';
const SP_COMPANY_REGISTRATION_FINISHED = 'SP_COMPANY_REGISTRATION_FINISHED';

const CUSTOMER_PROFILE = 'CUSTOMER_PROFILE';
const SERVICE_PROVIDER_PROFILE = 'SERVICE_PROVIDER_PROFILE';

const SERVICE_PROVIDER_CONFIGURATION = 'SERVICE_PROVIDER_CONFIGURATION';
const EDIT_SP_EMPLOYEE_PROFILE = 'EDIT_SP_EMPLOYEE_PROFILE';
const ADD_SERVICE_PROVIDER_EMPLOYEE = 'ADD_SERVICE_PROVIDER_EMPLOYEE';

const PLAYBOOKS = 'PLAYBOOKS';
const CTC = 'CTC';

const ISSUES = 'ISSUES';
const INSIGHTS = 'INSIGHTS';
const INTEGRATIONS = 'INTEGRATIONS';
const AUTHENTICATIONS = 'AUTHENTICATIONS';
const ADD_INTEGRATION = 'ADD_INTEGRATION';
const REPORTS = 'REPORTS';

const MODERN_REGISTRATION = 'MODERN_REGISTRATION';
const MODERN_SIGN_IN = 'MODERN_SIGN_IN';

export const views = {
  DASHBOARD,
  SIGN_IN,
  SIGN_IN_CHANGE_PASSWORD,
  SIGN_IN_MFA_SETUP,
  SIGN_IN_MFA_CODE,
  SIGN_IN_VERIFY_EMAIL,
  SIGN_UP,
  MODERN_REGISTRATION,
  MODERN_SIGN_IN,
  WORKSPACE_INFO,
  CLIENT_INFO,
  REGISTRATION_FINISHED,
  SIGN_OUT,
  ACTIVITY_LOG,
  PROJECT_DETAILS,
  NEW_PROJECT,
  REQUESTS,
  PROJECT_ISSUES,
  AUTOMATIC_PROJECT_ISSUES,
  PROJECT_FINDINGS,
  PROJECT_GENERAL_INFORMATION,
  PROJECT_WORK_WITH_PROJECT,
  PROJECT_TECHNICAL_INFORMATION,
  USER_MANAGEMENT,
  SETTINGS,
  INVENTORY,
  NOT_AUTHORIZED,
  EMAIL_VERIFICATION,
  SP_FREELANCER_CLIENT_INFO,
  COMPANY_SERVICES,
  COMPANY_CERTIFICATION,
  SP_FREELANCER_REGISTRATION_FINISHED,
  COMPANY_INFO,
  COMPANY_SERVICES_SP,
  COMPANY_CERTIFICATIONS_SP,
  EMAIL_VERIFICATION_SP,
  SP_COMPANY_REGISTRATION_FINISHED,
  CUSTOMER_PROFILE,
  SERVICE_PROVIDER_PROFILE,
  SERVICE_PROVIDER_CONFIGURATION,
  EDIT_SP_EMPLOYEE_PROFILE,
  ADD_SERVICE_PROVIDER_EMPLOYEE,
  PLAYBOOKS,
  CTC,
  ISSUES,
  INSIGHTS,
  INTEGRATIONS,
  ADD_INTEGRATION,
  AUTHENTICATIONS,
  REPORTS,
};

export const REGISTRATION_ROUTE_MAP = {
  0: { name: views.SIGN_UP },
  1: { name: views.WORKSPACE_INFO },
  2: { name: views.CLIENT_INFO },
  3: { name: views.REGISTRATION_FINISHED },
};

export const SP_FREELANCER_REGISTRATION_ROUTE_MAP = {
  0: { name: views.SIGN_UP },
  1: { name: views.EMAIL_VERIFICATION },
  2: { name: views.SP_FREELANCER_CLIENT_INFO },
  3: { name: views.COMPANY_SERVICES },
  4: { name: views.COMPANY_CERTIFICATION },
  5: { name: views.SP_FREELANCER_REGISTRATION_FINISHED},
};

export const SP_COMPANY_REGISTRATION_ROUTE_MAP = {
  0: { name: views.SIGN_UP },
  1: { name: views.COMPANY_INFO },
  2: { name: views.COMPANY_SERVICES_SP },
  3: { name: views.COMPANY_CERTIFICATIONS_SP },
  4: { name: views.EMAIL_VERIFICATION_SP },
  5: { name: views.SP_COMPANY_REGISTRATION_FINISHED},
};

export const DEFAULT_LOGGED_IN_ROUTE = DASHBOARD;
export const DEFAULT_SP_LOGGED_IN_ROUTE = ACTIVITY_LOG;
